export function dataOrDefault<T>(data: T | undefined, defaultValue: T): T {
  return data || defaultValue
}
